export default "__VITE_ASSET__DJF8k84U__"